import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import services from '../services';
import withResponseHandling from './withResponseHandling';
import withMessage from './withMessage';
import { acCarteirasChanged } from '../store/actions';

const PAGE_SIZE = 25;

const withAvaliacoesSessoes = Component => {
  function WrapComponent(props) {
    const entidadeId = useSelector(state => state.entidade.current.default_entidade_id);
    const storeDispatch = useDispatch();

    const [sessoes, setSessoes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isRefetching, setIsRefetching] = useState(false);
    const [rowCount, setRowCount] = useState(0);
    const [rowSelection, setRowSelection] = useState({});
    const [pagination, setPagination] = useState({
      pageIndex: 0,
      pageSize: PAGE_SIZE
    });

    function updateStore(pData) {
      storeDispatch(acCarteirasChanged(pData));
    }

    const readSessoes = useCallback(
      (pParams = {}, pCallback) => {
        if (!sessoes.length) {
          setIsLoading(true);
        } else {
          setIsRefetching(true);
        }

        const xParams = {
          size: PAGE_SIZE,
          page: 1,
          sort: 'avaliacao_secao_id desc',
          ...pParams
        };

        services.secoes.list(
          xParams,
          rRes => {
            const xSessoes = Object.values(rRes.data || {});

            setSessoes(xSessoes);
            setRowCount(rRes.pages?.total_items || xSessoes.length);
            pCallback && pCallback(xSessoes);
          },
          rErr => {
            props.responseErrorHandling(rErr);
          },
          () => {
            setIsLoading(false);
            setIsRefetching(false);
          }
        );
      },
      [sessoes.length, props]
    );

    const deleteSessoes = (pSecaoId, onFinish) => {
      services.secoes.remove(
        { avaliacao_secao_id: pSecaoId },
        () => {
          props.onMessageSuccess('Seção excluída com sucesso');
          readSessoes({}, updateStore);
          setRowSelection({});
        },
        rErr => {
          props.responseErrorHandling(rErr);
        },
        () => {
          onFinish && onFinish();
        }
      );
    };

    const bulkDeleteSessoes = pRows => {
      const xSessoesId = pRows.map(xRow => xRow.original.avaliacao_secao_id).filter(Boolean);

      xSessoesId.forEach(xId => {
        deleteSessoes(xId);
      });
    };

    useEffect(() => {
      const xPage = pagination.pageIndex + 1;

      readSessoes({
        page: xPage,
        size: pagination.pageSize
      });
    }, [readSessoes, pagination.pageIndex, pagination.pageSize, entidadeId]);

    const xProps = {
      sessoes,
      isLoading,
      isRefetching,
      rowCount,
      rowSelection,
      pagination,
      setPagination,
      setRowSelection,
      readSessoes,
      deleteSessoes,
      bulkDeleteSessoes
    };

    return <Component {...xProps} />;
  }

  return withMessage(withResponseHandling(WrapComponent));
};

export default withAvaliacoesSessoes;
